const { fetchJSON } = window.BAO.Utils

export class HeaderCountrySelector extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.noLocationStored) {
      this.setupHeaderCountrySwitcher(
        window.localStorage.getItem(this.userLocationName),
      )
    } else {
      fetchJSON(`/browsing_context_suggestions.json`, {
        method: 'GET',
      }).then(res => {
        this.setupHeaderCountrySwitcher(res.detected_values.country.handle)
      })
    }
  }

  setupListeners () {
    super.setupListeners()

    this.onOptionClick = this.onOptionClick.bind(this)

    if (this.els?.options.exists) {
      this.els.options.elements.forEach(optionEl => {
        this.listeners.add(optionEl, 'change', this.onOptionClick)
      })
    }
  }

  onOptionClick (e) {
    const selectedOptionValue = e.currentTarget.value
    const selectedOptionCode =
      e.currentTarget.options[e.currentTarget.selectedIndex].dataset.code
    window.location.href = `${this.sites[selectedOptionValue].url}${window.location.pathname}?country=${selectedOptionCode}${this.sites[selectedOptionValue].currency}`
  }

  setupHeaderCountrySwitcher (countryCode) {
    if (countryCode === this.dataset.store) {
      window.localStorage.setItem(this.storageName, 'true')
      window.localStorage.setItem(this.userLocationName, countryCode)
      return
    }

    this.externalEls.localisation.elements.forEach(localisationEl => {
      localisationEl.innerText = window.localStorage.getItem(
        this.userLocationName,
      )
    })

    this.createOptionsList(countryCode)
  }

  createOptionsList (countryCode) {
    Object.entries(this.countries).forEach(([key, value]) => {
      const { name, site } = value
      const isCurrentSite = key.toLowerCase() === countryCode.toLowerCase()
      this.els.options.element.innerHTML += this.createOptionElement(
        key,
        site,
        isCurrentSite,
        name,
      )
    })
  }

  createOptionElement (code, site, isCurrentSite, country) {
    return `<option
      data-code="${code}"
      value="${site}"
      ${isCurrentSite ? 'selected' : ''}
    >
      ${country}
    </option>`
  }

  get currentCountryList () {
    return this.getAttribute('switcher-country-list')
  }

  get noChoiceMade () {
    return (
      window.localStorage.getItem(this.storageName) == null ||
      (window.localStorage.getItem(this.storageName) === undefined &&
        !Shopify.designMode)
    )
  }

  get noLocationStored () {
    return (
      window.localStorage.getItem(this.userLocationName) == null ||
      (window.localStorage.getItem(this.userLocationName) === undefined &&
        !Shopify.designMode)
    )
  }

  get storageName () {
    return `BAO-store-sunspel`
  }

  get userLocationName () {
    return `BAO-location-sunspel`
  }

  get sites () {
    return {
      UK: {
        url: 'https://sunspel.myshopify.com',
        currency: '',
      },
      US: { url: 'https://sunspel-us.myshopify.com', currency: '' },
      DE: { url: 'https://sunspel-de.myshopify.com', currency: '' },
      FR: { url: 'https://sunspel-fr.myshopify.com', currency: '' },
      EU: { url: 'https://sunspel-eu.myshopify.com', currency: '' },
      JP: { url: 'https://sunspel-jp.myshopify.com', currency: '' },
    }
  }

  get countries () {
    return window.theme.countries
  }
}

if (!customElements.get('header-country-selector')) {
  customElements.define('header-country-selector', HeaderCountrySelector)
}
